import * as React from 'react';
import * as styled from './styled';
import {Viewer} from 'components/Viewer';
import {ButtonVariant} from 'components/Button';
import {WebinarBanner} from "components/WebinarBanner";
import PrepareBlock from "./components/PrepareBlock";
import {ButtonDone} from "components/ButtonDone";
import {IconFilePDF, IconLike} from "icons";
import {WebinarViewerProps} from './types';

/**
 * The component webinar view.
 * @param {WebinarViewerProps} props
 * @return {React.ReactElement<WebinarViewerProps>}
 * @constructor
 */
export default function WebinarViewer(
  {
    webinar,
  }: WebinarViewerProps,
): React.ReactElement<WebinarViewerProps> {
  const [isLearned, setLearned] = React.useState(false);

  const _tempFiles = [
    'тестовый файл 1',
    'тестовый файл 2',
  ];

  const _tempList = [
    'Певый текстовый текст',
    'Второй текстовый текст',
    'Третий текстовый текст',
  ]

  /**
   * Render header.
   * @return {JSX.Element}
   */
  function renderHeader(): JSX.Element {
    return (
      <React.Fragment>
        <styled.BannerWrapper>
          <styled.BannerTitle>
            {webinar.title}
          </styled.BannerTitle>
          <WebinarBanner
            date={webinar.date}
          />
          <styled.BannerPlay />
        </styled.BannerWrapper>
        <Viewer.Header
          preview={null}
          tags={webinar.tags}
          title={webinar.title}
          description={webinar.description}
          authorId={webinar.userID}
        />
      </React.Fragment>
    );
  }

  /**
   * Render webinar files.
   * @return {JSX.Element}
   */
  function renderWebinarFiles() {
    return _tempFiles.map(file => (
      <styled.FileBox>
        <IconFilePDF />
        {file}
      </styled.FileBox>
    ))
  }

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    return (
      <div>
        <styled.Content>
          <styled.ContentSection>
            <styled.ContentLabel>подготовка к трансляции</styled.ContentLabel>
            <PrepareBlock list={_tempList} />
          </styled.ContentSection>
          <styled.ContentSection>
            <styled.ContentLabel>Конспект трансляции</styled.ContentLabel>
            <styled.Files>
              {renderWebinarFiles()}
            </styled.Files>
          </styled.ContentSection>
        </styled.Content>
      </div>
    );
  }

  /**
   * Render footer.
   * @return {JSX.Element}
   */
  function renderFooter(): JSX.Element {
    return (
      <styled.Footer>
        <ButtonDone
          text={'Изучено'}
          icon={<IconLike />}
          active={isLearned}
          onClick={() => setLearned(prev => !prev)}
        />
        <styled.Button variant={ButtonVariant.Outline}>
          Вернуться к содержанию
        </styled.Button>
      </styled.Footer>
    );
  }

  return (
    <Viewer>
      {{
        header: renderHeader(),
        content: renderContent(),
        footer: renderFooter(),
      }}
    </Viewer>
  );
}
